const mLogin = {
  name: 'mLogin',
  path: '',
  meta: {
    title: '登录'
  },
  component: resolve => require(['../../../pages/m/login'], resolve)
}

export default mLogin
